import Axios from 'axios'
import axios from './ajax'
import { getAppVer } from '@/assets/js/utils'
import axiosConfig from '@/config/config'
import { getSStorage } from '../utils'

const CHANNELURL = {
  getConfig: 'atourlife/marketConfig/getMarketConfig',
  getPhoneMessage: 'atourlife/verifyCode/getVerifyCodeByTypeForH5',
  getTackets: '/atourlife/login/receiveRedPacketByVerifyCode',
  getTacketList: '/atourlife/coupon/getCouponsListByMarketIdNotToken',
  getTokenByTicket: 'atourlife/user/getUserTokenByTicket',
  checkUserInfoBind: 'atourlife/miniapp/login/checkUserInfoBind'
}

export function GetConfig (params) {
  return axios.post(CHANNELURL.getConfig, params)
}

export function GetPhoneMessage (params) {
  return axios.post(CHANNELURL.getPhoneMessage, params.params, {
    headers: params.config,
    isNeedTdSign: true
  })
}

export function GetTackets (params) {
  return axios.post(CHANNELURL.getTackets, params.params, Object.assign({}, params.config, {
    isNeedTdSign: true
  }))
}

export function GetTacketList (params) {
  return axios.post(CHANNELURL.getTacketList, params)
}

export function GetUserToken (params) {
  const query = `?appVer=${getAppVer()}&channelId=300001&platType=${getSStorage('platType') || 5}`
  return Axios.post(axiosConfig.JAVA_SERVER + CHANNELURL.getTokenByTicket + query, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function CheckUserInfoBind (params) {
  return axios.get(CHANNELURL.checkUserInfoBind, { params }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/query/api.js